import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

type Props = FieldProps & {
    size: 'normal' | 'big';
};

export function ShouldDedupeRadio(props: Props) {
    const {input, size} = props;

    // Our component expects a string, and we also need to default
    // to 'yes' when there's not a value set in the database.
    //
    // Of course, redux-form doesn't return undefined, but rather
    // an empty string, so need to check all three cases just in case.
    const getValue = (value?: 'boolean' | 'string'): 'yes' | 'no' => {
        if (typeof value === 'boolean') {
            return value ? 'yes' : 'no';
        } else if (!value) {
            return 'yes';
        } else {
            return 'yes';
        }
    };

    return (
        <RadioGroup
            name={input.name}
            selectedValue={getValue(input.value)}
            size={size}
            onChange={(newValue) => {
                input.onChange(newValue === 'yes');
            }}
        >
            <Radio value='yes'>Yes, update existing companies based on name</Radio>
            <Radio value='no'>No, always create a new company</Radio>
        </RadioGroup>
    );
}
